<template>
  <div class="quiz-section" ref="quiz_top">
      <div v-if= "didLoad">
        <quiz-mandatory-video
          v-if="quizStarted && sections[currentSection].isMediaPresent && reloaded" 
          :currentSection="currentSection"
          :videoLink="sections[currentSection].video_link"
        />
          <div class="text-h3 quiz-title">
              {{quizName}}
          </div>
          <div class="text-body1 mb-10">
            Welcome to the Quizzes platform! You can miss {{allowedIncorrect}} question<span v-if="allowedIncorrect > 1">s</span> to pass.
            There <span v-if="totalSectionCount > 1">is</span><span v-else>are</span> {{totalSectionCount}} section<span v-if="totalSectionCount > 1">s</span> in this quiz.
            Once you've passed the quiz, you will reach a page that contains a button to take you 
            back to the site that directed you to this platform. Good luck!
          </div>

          <div v-if="!quizStarted">
            <v-btn dark color="primary" @click="startQuiz">Continue<v-icon right>mdi-chevron-right</v-icon></v-btn>
          </div>

          <div v-else>
              <div v-if="totalSectionCount > 1">
                  <div class="line"/>
                  <div class="section">
                      <div class="text-h5 section-no">Section {{ currentSection + 1 }} out of {{ totalSectionCount }}</div>
                  </div>
                  <div class="line"/>
              </div>
            <v-row class="quiz-container">
              <v-col :md="sections[currentSection].isMediaPresent ? 7 : 12" cols="12">
                  <quiz-card
                      v-for="data in sections[currentSection].questions"
                      :key="data.id"
                      :question="data.question_text"
                      :options="data.answers"
                      :questionId="data.id"
                      :optionType="data.type"
                      :image="data.image"
                  />
              </v-col>
              <v-col md="5" cols="12" v-if="sections[currentSection].isMediaPresent && this.reloaded">
                <quiz-video
                  :videoLink="sections[currentSection].video_link"
                  :transcript="sections[currentSection].transcript"
                  id="quiz-video-player"
                />
              </v-col>
            </v-row>
            <quiz-pagination
            :currentSection="currentSection + 1"
            :totalSectionCount="totalSectionCount"
            @update:section="updateSection"
            />
          </div>
      </div>
  </div>
</template>

<script>
import QuizCard from './QuizCard.vue'
import QuizPagination from './QuizPagination.vue';
import QuizMandatoryVideo from './QuizMandatoryVideo.vue';
import QuizVideo from './QuizVideo.vue';

import { mapState } from 'vuex';

export default {
  components: { QuizCard, QuizPagination, QuizMandatoryVideo, QuizVideo },
    name: 'quizSection',
    computed: {
      ...mapState(['quizFinished', 'quizStarted', 'videosWatched', 'numQuestions']),
    },
    data: function(){
        return {
            quizName: "",
            currentSection: 0,
            totalSectionCount: 0,
            dialog: false,
            allowedIncorrect: 0,
            sections: [],
            didLoad: false,
            slug: this.$route.params.slug,
            reloaded:true
        }
    },
    methods: {
      async init(){
          if (this.slug != this.$store.state.slug) {
            this.$store.commit('RESET', this.slug)
          }

          let takeQuizResponse = (await this.$store.dispatch('startQuiz',{slug:this.slug}));

          if (takeQuizResponse.status != 200) {
            this.$router.push({name: 'homePage'});
          }
          
          if (takeQuizResponse.data.passed == true) {
            this.$router.push({name: 'quizPassed'});
          }

          let questionsResponse = (await this.$store.dispatch('getQuestions')).data;

          this.allowedIncorrect = (await this.$store.dispatch('getIncorrectAllowed')).data.data;

          this.quizName = questionsResponse[0].name;
          this.$store.commit('UPDATE_NUM_QUESTIONS', 0);
          for (let sectionData of questionsResponse) {
              this.$store.commit('UPDATE_NUM_QUESTIONS', this.numQuestions + sectionData.questions.length)
              this.sections.push(sectionData);
              this.sections[this.totalSectionCount].isMediaPresent = sectionData.video_link!=null ? true : false;
              this.totalSectionCount += 1;
          }
          this.didLoad = true;
      },

      scrollToTop() {
        this.$nextTick(() => {
          this.$vuetify.goTo(this.$refs.quiz_top, {duration: 0})
        });
      },

      startQuiz() {
        this.$store.commit('UPDATE_QUIZ_STARTED', true);
        this.scrollToTop();
      },

      updateSection(change) {
          this.currentSection += change;
          this.scrollToTop();
      },
    },
    
    async mounted(){
      await this.init();
      document.title = `Quizzes | ${this.quizName}`;
    },

    watch: {
      currentSection() {
        /*
          This is an incredibly hacky implementation
          but it's the only one I've figured out how to get it to work.
          The video player doesn't like it when you change the source URL
          without remounting. If you do change it, you lose all the listeners
          for some reason, meaning you can't close out the video when it's finished.
          This is an ultra crazy way to force the video player to unmount and remount.
          Hopefully in the future, someone smarter than me can figure out how to circumvent this.
        */
        if (this.sections[this.currentSection].isMediaPresent) {
          this.reloaded = false;
          this.$nextTick(() => {
            this.reloaded = true;
          });
        }
      }
    }
}
</script>


<style scoped>
.quiz-cards{
    background-color: #e9e6e6;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-right: 1rem;
}

.quiz-cards-expand{
    width: 100%;
}

.quiz-container{
    display: flex;
}

.section {
    margin: 5px;
    display: flex;
    flex-direction: column;
}

.section-no {
    color: #000000;
    font-size: 25px;
    font-weight: 500;
    float:left;
}

.line { 
  margin: 1rem 0;
  width: 100%;
  display:inline-block; 
  border-bottom: 3px solid #bebebe;
} 

.quiz-title{
    color: #000000;
    font-weight: bold ;
    margin-bottom: 3rem;
}

@media only screen and (max-width: 960px) {
  .quiz-container {
    flex-direction: column-reverse;
  }

  #quiz-video-player {
    position: sticky;
    top: 20;
  }
}
</style>